import RecoverStep from "../recover_step";
import {attachSelectableHandler} from "../../utils/recover_utils";
import {AJAX_DATA_TYPE_JSON} from "../../utils/recover_consts";

const TEMPLATE = 'virtualization-type';

export default class SetVirtualizationType extends RecoverStep {

    constructor(stepTemplate = TEMPLATE, cloudController = 'cloud') {
        super(stepTemplate);
        this.cloudController = cloudController;
    }

    open(data, el, fr, previousStep) {
        let step;
        let url = `/client/get_failover_status/${data.clientId}/`;
        if(data.applianceId) {
            url = url + data.applianceId;
        }
        // in case when we're moving backward
        if (!data.device_id) {
            data.devices = null;
            data.recovery.device_id = null;
            data.recovery.device_name = null;
        }
        data.tmp.previousStep = fr.currentStep;
        if(data.recovery.virtualization.isLocal) {
            step = data.deviceId ? 'setupLocalVm' : 'browseLocalVms';
        } else {
            step = 'setVirtualizationRunbook';
            $.ajax({
                type: "GET",
                url: url,
                dataType: AJAX_DATA_TYPE_JSON,
                async: false,
                contentType: "application/json",
                success: (response) => {
                    if (response.data.isAutoStopEnabled) {
                        step = 'setVoVmsAutoStop';
                        data.recovery.virtualization.autostopEnabled = true;
                    }
                    if (response.data.status) {
                        if (response.data.isForCurrentService) {
                            $.getScript(`/appliance/appliance_failover_script/${data.applianceId}`);
                            fr.close();
                        } else {
                            if (!data.applianceId) {
                                $.getScript(`/client/client_failover_script/${data.clientId}`);
                                fr.close();
                            } else {
                                fr.goTo('showVOExist');
                            }
                        }
                    }
                }
            }).fail(fr.defaultAJAXErrorHandler);
        }
        data.render = {
            loadingComplete: true,
            nextStep: step
        };
        data.recovery.virtualization.type = null;
        data.useBrowse = false;
    }

    postRender(data, el, fr) {
        attachSelectableHandler(el, function(d) {
            data.recovery.virtualization.type = d.type;
            data.recovery.virtualization.isTest = +(d.type === 'test');
        });
    }

    transitionNext(data, el, fr) {
        data.render.loadingComplete = false;
        fr.render('setVirtualizationType');
        $.getScript(`/client/client_failover_script/${data.clientId}/${data.recovery.virtualization.isTest}`, function() {
            fr.close();
        });
    }

}
